import React from "react";

import asIcon from "./asIcon";

export default asIcon(
  ({ color }) =>
    <path fill={color} d="M56.9 50l25.4-28a5.9 5.9 0 0 0 0-7.7 4.6 4.6 0 0 0-6.9 0L50 42.3l-25.3-28a4.6 4.6 0 0 0-6.9 0 5.9 5.9 0 0 0 0 7.7l25.3 28-25.4 28a5.9 5.9 0 0 0 0 7.7 4.6 4.6 0 0 0 6.9 0l25.4-28 25.3 28a4.6 4.6 0 0 0 6.9 0 5.9 5.9 0 0 0 0-7.7z" />,
);
